import styled from 'styled-components';
import { Container } from 'react-bootstrap';

/** Shared page width - matches ModernHeader and home page sections. */
const PageContainer = styled(Container)`
  box-sizing: border-box;
`;

export default PageContainer;
